if (!customElements.get("vehicle-filter")) {
  const ICONS = {
    year: '<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>',
    km: '<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path fill="currentColor" fill-rule="evenodd" d="M12 4.02C6.537 4.02 2 8.5 2 14.047c0 2.139.711 4.128 1.84 5.758l.318.457.421-.365 1.752-1.517-.655-.756-1.319 1.142a9.2 9.2 0 0 1-1.302-3.746H5.5v-.424l5.584.35c.15.35.488.574.916.574.583 0 1-.417 1-1 0-.584-.417-1-1-1-.365 0-.665.163-.838.428l-6.354-.397-.03.469H3a9 9 0 0 1 2.305-5.987l1.842 1.84.706-.707-1.841-1.84A8.97 8.97 0 0 1 11.5 5.034V7.52h1V5.033a8.95 8.95 0 0 1 5.496 2.275l-1.85 1.859.708.705 1.849-1.856A9 9 0 0 1 21 14.02h-2.5v1h2.445a9.2 9.2 0 0 1-1.302 3.746l-1.32-1.142-.654.756 1.752 1.517.42.365.318-.457c1.13-1.63 1.841-3.62 1.841-5.758C22 8.5 17.533 4.02 12 4.02" clip-rule="evenodd"></path></svg>',
    dmc: '<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path fill="currentColor" fill-rule="evenodd" d="M12 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4m2.236 4a3 3 0 1 0-4.472 0H7.11l-.095.379-3 12.005-.155.62h16.28l-.155-.62-3-12.005L16.891 8h-2.655M12 9H7.89L5.14 20.005h13.72L16.11 9z" clip-rule="evenodd"></path></svg>',
  };

  const DMC_BUCKETS = [
    { key: "1", label: "do 3,5 t", min: 1, max: 3500 },
    { key: "2", label: "3,5 – 7,5 t", min: 3501, max: 7500 },
    { key: "3", label: "7,5 – 12 t", min: 7501, max: 12000 },
    { key: "4", label: "powyżej 12 t", min: 12001, max: Infinity },
  ];

  const KM_OPTIONS = [
    { key: "100000", label: "do 100 000 km", max: 100000 },
    { key: "200000", label: "do 200 000 km", max: 200000 },
    { key: "300000", label: "do 300 000 km", max: 300000 },
    { key: "400000", label: "do 400 000 km", max: 400000 },
    { key: "500000", label: "do 500 000 km", max: 500000 },
    { key: "500000+", label: "powyżej 500 000 km", min: 500001 },
  ];

  const STATE_KEYS = [
    "cat",
    "sub",
    "marka",
    "model",
    "yearFrom",
    "yearTo",
    "priceFrom",
    "priceTo",
    "km",
    "body",
    "dmc",
  ];

  const NUMERIC_KEYS = ["yearFrom", "yearTo", "priceFrom", "priceTo"];

  const FIELD_STATE = {
    marka: ["marka"],
    model: ["model"],
    year: ["yearFrom", "yearTo"],
    price: ["priceFrom", "priceTo"],
    km: ["km"],
    body: ["body"],
    dmc: ["dmc"],
  };

  const matchesKm = (item, key) => {
    const option = KM_OPTIONS.find((entry) => entry.key === key);
    if (!option || !item.k) return false;
    if (option.min !== undefined) return item.k >= option.min;
    return item.k <= option.max;
  };

  const escapeHtml = (value) =>
    String(value).replace(
      /[&<>"']/g,
      (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char],
    );

  const groupDigits = (number, separator) =>
    String(Math.round(number)).replace(/\B(?=(\d{3})+(?!\d))/g, separator);

  const formatPrice = (number) => `${groupDigits(number, ".")} zł`;

  const pluralOffers = (count) => {
    if (count === 1) return "oferta";
    const lastTwo = count % 100;
    const last = count % 10;
    return last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14) ? "oferty" : "ofert";
  };

  const parseNumber = (value) => {
    const digits = String(value).replace(/\D/g, "");
    return digits === "" ? "" : parseInt(digits, 10);
  };

  class VehicleFilter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }
      this.initialized = true;

      // "collection" mode: the same filter lives on a collection page, between the
      // standard toolbar and the standard grid, and opens with the "Filtry" button.
      this.isCollection = this.dataset.mode === "collection";
      if (this.isCollection) {
        const actions = document.getElementById("CollectionActions");
        if (!actions) {
          // Not a standard collection layout: keep the standard UI untouched.
          this.hidden = true;
          return;
        }
        actions.after(this);
        this.classList.add("is-placed");
        const sortSelect = document.getElementById("collection-sort-order");
        this.sortBy = sortSelect ? sortSelect.value : "";
      }

      this.items = [];
      this.matched = [];

      try {
        this.categories = JSON.parse(this.dataset.categories || "[]");
      } catch (error) {
        this.categories = [];
      }

      this.perPage = parseInt(this.dataset.perPage, 10) || 8;
      this.shown = this.perPage;

      this.selects = {};
      this.querySelectorAll("select[data-filter]").forEach((select) => {
        this.selects[select.dataset.filter] = select;
      });

      this.inputs = {};
      this.querySelectorAll("[data-range-input]").forEach((input) => {
        this.inputs[input.dataset.rangeInput] = input;
      });

      this.ranges = {};
      this.querySelectorAll("[data-range]").forEach((field) => {
        this.ranges[field.dataset.range] = {
          field,
          toggle: field.querySelector(".vf-popover-toggle"),
          value: field.querySelector(".vf-popover-value"),
          panel: field.querySelector(".vf-popover-panel"),
          hint: field.querySelector(".vf-popover-hint"),
          apply: field.querySelector(".vf-apply"),
          placeholder: field.querySelector(".vf-popover-value").textContent,
        };
      });

      this.tabsEl = this.querySelector(".vf-tabs:not(.vf-subtabs)");
      this.subTabsEl = this.querySelector(".vf-subtabs");
      this.subKey = null;
      this.fieldEls = {};
      this.querySelectorAll(".vf-field[data-field]").forEach((element) => {
        this.fieldEls[element.dataset.field] = element;
      });

      [this.tabsEl, this.subTabsEl].filter(Boolean).forEach((element) => {
        element.addEventListener("scroll", () => this.updateTabsFade(element), { passive: true });
      });
      window.addEventListener("resize", () => {
        [this.tabsEl, this.subTabsEl].filter(Boolean).forEach((element) => this.updateTabsFade(element));
      });

      this.countEl = this.querySelector(".vf-count");
      this.resetButton = this.querySelector(".vf-reset");
      this.showAllButton = this.querySelector(".vf-show-all");
      this.gridEl = this.querySelector(".vf-grid");
      this.emptyEl = this.querySelector(".vf-empty");
      this.errorEl = this.querySelector(".vf-error");
      this.moreWrap = this.querySelector(".vf-more");
      this.moreButton = this.querySelector(".vf-more-button");

      this.panelEl = this.querySelector(".vf-panel");
      this.fab = this.querySelector(".vf-fab");
      if (this.fab) {
        this.fabCount = this.fab.querySelector(".vf-fab-count");
        // Lives on <body> so no transformed ancestor can break position: fixed.
        document.body.appendChild(this.fab);
        this.fab.addEventListener("click", () =>
          this.isCollection ? this.togglePanel(true) : this.scrollToFilters(),
        );

        let ticking = false;
        window.addEventListener(
          "scroll",
          () => {
            if (ticking) {
              return;
            }
            ticking = true;
            requestAnimationFrame(() => {
              ticking = false;
              this.updateFab();
            });
          },
          { passive: true },
        );
        window.addEventListener("resize", () => this.updateFab());
      }

      this.state = this.readUrl();
      this.pruneHiddenFilters();
      this.bindEvents();

      if (this.isCollection) {
        this.setupCollection();
      }

      this.loadData()
        .then((items) => {
          this.items = items;
          this.classList.remove("is-loading");
          this.update();
          this.centerActiveTab(this.tabsEl, false);
          this.centerActiveTab(this.subTabsEl, false);
        })
        .catch(() => {
          this.classList.remove("is-loading");
          this.countEl.textContent = "";
          this.errorEl.hidden = false;
        });
    }

    setupCollection() {
      this.filterButton = document.querySelector(".button-sidebar-drawer-open");
      if (this.filterButton) {
        this.filterBadge = document.createElement("span");
        this.filterBadge.className = "vf-button-badge";
        this.filterBadge.hidden = true;
        this.filterButton.appendChild(this.filterBadge);

        // Capture phase: the click never reaches the standard filter drawer.
        document.addEventListener(
          "click",
          (event) => {
            if (event.target.closest(".button-sidebar-drawer-open")) {
              event.preventDefault();
              event.stopImmediatePropagation();
              this.togglePanel();
            }
          },
          true,
        );
      }

      const sortSelect = document.getElementById("collection-sort-order");
      sortSelect?.addEventListener("change", () => {
        this.sortBy = sortSelect.value;
        this.loadData()
          .then((items) => {
            this.items = items;
            this.update();
          })
          .catch(() => {});
      });

      this.querySelector(".vf-overlay")?.addEventListener("click", () => this.togglePanel(false));
      this.querySelector(".vf-drawer-close")?.addEventListener("click", () => this.togglePanel(false));
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && this.classList.contains("is-open")) {
          this.togglePanel(false);
        }
      });

      if (this.isFiltered()) {
        document.documentElement.classList.add("vf-collection-filtered");
      }
    }

    togglePanel(force) {
      const open = force === undefined ? !this.classList.contains("is-open") : force;
      this.classList.toggle("is-open", open);
      document.documentElement.classList.toggle("vf-drawer-open", open);
      this.filterButton?.setAttribute("aria-expanded", open ? "true" : "false");
      this.updateFab();
      if (open) {
        this.querySelector(".vf-drawer-close")?.focus({ preventScroll: true });
      } else {
        this.closePopovers();
        this.filterButton?.focus({ preventScroll: true });
      }
    }

    bindEvents() {
      this.tabsEl?.addEventListener("click", (event) => {
        const tab = event.target.closest(".vf-tab");
        if (!tab) {
          return;
        }
        STATE_KEYS.forEach((key) => {
          this.state[key] = "";
        });
        this.state.cat = tab.dataset.cat;
        this.pruneHiddenFilters();
        this.closePopovers();
        this.update();
        this.centerActiveTab(this.tabsEl, true);
      });

      this.subTabsEl?.addEventListener("click", (event) => {
        const tab = event.target.closest(".vf-subtab");
        if (!tab || tab.disabled) {
          return;
        }
        this.state.sub = tab.dataset.sub;
        this.closePopovers();
        this.update();
        this.centerActiveTab(this.subTabsEl, true);
      });

      Object.entries(this.selects).forEach(([key, select]) => {
        select.addEventListener("change", () => {
          this.state[key] = NUMERIC_KEYS.includes(key) ? parseNumber(select.value) : select.value;
          this.update();
        });
      });

      Object.entries(this.ranges).forEach(([name, range]) => {
        range.toggle.addEventListener("click", () => {
          const willOpen = range.panel.hidden;
          this.closePopovers();
          if (willOpen) {
            this.openPopover(name);
          }
        });

        range.apply.addEventListener("click", () => {
          this.applyRange(name);
        });

        range.panel.addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            this.applyRange(name);
          }
        });
      });

      document.addEventListener("click", (event) => {
        if (!event.target.closest(".vf-popover")) {
          this.closePopovers();
        }
      });

      this.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          this.closePopovers();
        }
      });

      this.resetButton.addEventListener("click", () => {
        STATE_KEYS.forEach((key) => {
          if (key !== "cat") {
            this.state[key] = "";
          }
        });
        this.update();
      });

      this.showAllButton.addEventListener("click", () => {
        if (this.isCollection) {
          // Collection page: the button just closes the panel and shows the results.
          this.togglePanel(false);
        } else {
          this.shown = this.matched.length;
          this.renderResults(false);
        }
        this.querySelector(".vf-results").scrollIntoView({ behavior: "smooth", block: "start" });
      });

      this.moreButton.addEventListener("click", () => {
        this.shown += this.perPage;
        this.renderResults(false);
      });
    }

    openPopover(name) {
      const range = this.ranges[name];
      const prefix = name;
      this.inputs[`${prefix}From`].value =
        this.state[`${prefix}From`] === "" ? "" : this.state[`${prefix}From`];
      this.inputs[`${prefix}To`].value =
        this.state[`${prefix}To`] === "" ? "" : this.state[`${prefix}To`];
      range.panel.hidden = false;
      range.toggle.setAttribute("aria-expanded", "true");
      range.field.classList.add("is-open");
      this.inputs[`${prefix}From`].focus();
    }

    closePopovers() {
      Object.values(this.ranges).forEach((range) => {
        range.panel.hidden = true;
        range.toggle.setAttribute("aria-expanded", "false");
        range.field.classList.remove("is-open");
      });
    }

    applyRange(name) {
      let from = parseNumber(this.inputs[`${name}From`].value);
      let to = parseNumber(this.inputs[`${name}To`].value);

      if (from !== "" && to !== "" && from > to) {
        [from, to] = [to, from];
      }

      this.state[`${name}From`] = from;
      this.state[`${name}To`] = to;
      this.closePopovers();
      this.update();
    }

    readUrl() {
      const params = new URLSearchParams(window.location.search);
      const state = {};
      STATE_KEYS.forEach((key) => {
        const raw = params.get(`vf_${key}`) || "";
        state[key] = NUMERIC_KEYS.includes(key) ? parseNumber(raw) : raw;
      });
      return state;
    }

    syncUrl() {
      const url = new URL(window.location.href);
      STATE_KEYS.forEach((key) => {
        const value = this.state[key];
        const isDefaultCategory = key === "cat" && value === this.categories[0]?.h;
        if (value === "" || value === undefined || isDefaultCategory) {
          url.searchParams.delete(`vf_${key}`);
        } else {
          url.searchParams.set(`vf_${key}`, value);
        }
      });
      window.history.replaceState(null, "", url);
    }

    async loadData() {
      const sortBy = this.sortBy || "";
      const cacheKey = `vf-data-v4:${this.dataset.url}${sortBy ? `|${sortBy}` : ""}`;

      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey));
        if (cached && Date.now() - cached.time < 10 * 60 * 1000) {
          return cached.items;
        }
      } catch (error) {
        /* ignore storage problems */
      }

      const pageUrl = (page) => {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set("view", "vehicle-data");
        url.searchParams.set("page", page);
        if (sortBy) {
          url.searchParams.set("sort_by", sortBy);
        }
        return url.toString();
      };

      const fetchPage = (page) =>
        fetch(pageUrl(page)).then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.json();
        });

      const first = await fetchPage(1);
      const rest = [];
      for (let page = 2; page <= first.pages; page++) {
        rest.push(fetchPage(page));
      }
      const others = await Promise.all(rest);
      const items = [first, ...others].flatMap((data) => data.items);

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ time: Date.now(), items }));
      } catch (error) {
        /* ignore storage problems */
      }

      return items;
    }

    match(item, skip) {
      const s = this.state;

      if (skip !== "cat" && s.cat && !item.cs.includes(s.cat)) return false;
      if (skip !== "sub" && s.sub && !item.cs.includes(s.sub)) return false;
      if (skip !== "marka" && s.marka && item.b !== s.marka) return false;
      if (skip !== "model" && s.model && item.m !== s.model) return false;
      if (skip !== "body" && s.body && item.n !== s.body) return false;

      if (skip !== "dmc" && s.dmc) {
        const bucket = DMC_BUCKETS.find((entry) => entry.key === s.dmc);
        if (bucket && !(item.d >= bucket.min && item.d <= bucket.max)) return false;
      }

      if (skip !== "year" && (s.yearFrom !== "" || s.yearTo !== "")) {
        if (!item.y) return false;
        if (s.yearFrom !== "" && item.y < s.yearFrom) return false;
        if (s.yearTo !== "" && item.y > s.yearTo) return false;
      }

      if (skip !== "price" && (s.priceFrom !== "" || s.priceTo !== "")) {
        if (!item.c) return false;
        if (s.priceFrom !== "" && item.c < s.priceFrom) return false;
        if (s.priceTo !== "" && item.c > s.priceTo) return false;
      }

      if (skip !== "km" && s.km && !matchesKm(item, s.km)) return false;

      return true;
    }

    visibleFields() {
      if (this.isCollection && this.dataset.fields) {
        return this.dataset.fields.split(",");
      }
      const category = this.categories.find((entry) => entry.h === this.state.cat);
      return category ? category.f : Object.keys(FIELD_STATE);
    }

    pruneHiddenFilters() {
      if (this.categories.length && !this.categories.some((entry) => entry.h === this.state.cat)) {
        this.state.cat = this.categories[0].h;
      } else if (!this.categories.length) {
        this.state.cat = "";
      }

      const activeCategory = this.categories.find((entry) => entry.h === this.state.cat);
      if (this.state.sub && !(activeCategory?.s || []).some((entry) => entry.h === this.state.sub)) {
        this.state.sub = "";
      }

      const visible = this.visibleFields();
      Object.entries(FIELD_STATE).forEach(([field, keys]) => {
        if (!visible.includes(field)) {
          keys.forEach((key) => {
            this.state[key] = "";
          });
        }
      });
    }

    applyVisibility() {
      const visible = this.visibleFields();
      Object.entries(this.fieldEls).forEach(([field, element]) => {
        element.hidden = !visible.includes(field);
      });
    }

    updateTabsFade(element) {
      if (!element) {
        return;
      }
      const maxScroll = element.scrollWidth - element.clientWidth;
      element.classList.toggle("has-more-left", element.scrollLeft > 4);
      element.classList.toggle("has-more-right", element.scrollLeft < maxScroll - 4);
    }

    centerActiveTab(element, smooth) {
      const active = element?.querySelector(".vf-tab.is-active");
      if (!active) {
        return;
      }
      const left = active.offsetLeft - (element.clientWidth - active.offsetWidth) / 2;
      element.scrollTo({ left: Math.max(0, left), behavior: smooth ? "smooth" : "auto" });
      this.updateTabsFade(element);
    }

    renderCategory() {
      if (!this.tabsEl) {
        return;
      }

      const pool = this.items.filter((item) => this.match(item, "cat"));
      this.tabsEl.querySelectorAll(".vf-tab").forEach((tab) => {
        const handle = tab.dataset.cat;
        const count = handle ? pool.filter((item) => item.cs.includes(handle)).length : pool.length;
        const active = handle === this.state.cat;
        const total = this.items.filter((item) => item.cs.includes(handle)).length;
        tab.hidden = total === 0 && !active;
        tab.querySelector(".vf-tab-count").textContent = count;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-pressed", active ? "true" : "false");
      });
      this.updateTabsFade(this.tabsEl);
      this.renderSubcategories();
    }

    renderSubcategories() {
      const element = this.subTabsEl;
      if (!element) {
        return;
      }

      const category = this.categories.find((entry) => entry.h === this.state.cat);
      const subs = category?.s || [];
      element.hidden = subs.length === 0;

      if (!subs.length) {
        element.innerHTML = "";
        this.subKey = null;
        return;
      }

      const key = `${this.state.cat}|${subs.map((entry) => entry.h).join(",")}`;
      if (key !== this.subKey) {
        this.subKey = key;
        element.scrollLeft = 0;
        element.innerHTML = [{ h: "", t: "Wszystkie" }, ...subs]
          .map(
            (entry) =>
              `<button type="button" class="vf-tab vf-subtab" data-sub="${escapeHtml(entry.h)}" aria-pressed="false">
                <span class="vf-tab-label">${escapeHtml(entry.t)}</span>
                <span class="vf-tab-count"></span>
              </button>`,
          )
          .join("");
      }

      const pool = this.items.filter((item) => this.match(item, "sub"));
      const categoryItems = this.items.filter((item) => item.cs.includes(this.state.cat));
      let visibleSubs = 0;
      element.querySelectorAll(".vf-subtab").forEach((tab) => {
        const handle = tab.dataset.sub;
        const count = handle ? pool.filter((item) => item.cs.includes(handle)).length : pool.length;
        const total = handle
          ? categoryItems.filter((item) => item.cs.includes(handle)).length
          : categoryItems.length;
        const active = handle === this.state.sub;
        tab.hidden = handle !== "" && total === 0 && !active;
        if (handle !== "" && !tab.hidden) {
          visibleSubs++;
        }
        tab.querySelector(".vf-tab-count").textContent = count;
        tab.classList.toggle("is-active", active);
        tab.classList.toggle("is-empty", count === 0 && !active);
        tab.disabled = count === 0 && !active;
        tab.setAttribute("aria-pressed", active ? "true" : "false");
      });
      element.hidden = visibleSubs === 0;
      this.updateTabsFade(element);
    }

    update() {
      this.applyVisibility();
      this.renderCategory();
      this.renderFacets();
      this.renderYears();
      this.renderRangeButtons();
      this.renderKm();
      this.renderDmc();
      this.renderResults(true);
      this.syncUrl();
    }

    fillSelect(select, entries, selected) {
      const placeholder = select.options[0];
      select.replaceChildren(
        placeholder,
        ...entries.map(({ value, label, disabled }) => {
          const option = new Option(label, value);
          option.disabled = Boolean(disabled);
          return option;
        }),
      );
      select.value = selected === "" || selected === undefined ? "" : String(selected);
    }

    renderFacets() {
      const facets = [
        { key: "marka", field: "b" },
        { key: "model", field: "m" },
        { key: "body", field: "n" },
      ];

      facets.forEach(({ key, field }) => {
        const counts = new Map();
        this.items.forEach((item) => {
          if (item[field] && this.match(item, key)) {
            counts.set(item[field], (counts.get(item[field]) || 0) + 1);
          }
        });

        const selected = this.state[key];
        if (selected && !counts.has(selected)) {
          counts.set(selected, 0);
        }

        const entries = [...counts.keys()]
          .sort((a, b) => a.localeCompare(b, "pl"))
          .map((value) => ({ value, label: `${value} (${counts.get(value)})` }));

        this.fillSelect(this.selects[key], entries, selected);
      });

      const bodySelect = this.selects.body;
      const hasBodyData = this.items.some((item) => item.n);
      bodySelect.disabled = !hasBodyData;
      bodySelect.closest(".vf-field").classList.toggle("is-empty", !hasBodyData);
      bodySelect.title = hasBodyData ? "" : "Pole „Typ nadwozia” nie jest jeszcze uzupełnione w produktach";
    }

    renderYears() {
      const years = new Set();
      this.items.forEach((item) => {
        if (item.y && this.match(item, "year")) {
          years.add(item.y);
        }
      });

      [this.state.yearFrom, this.state.yearTo].forEach((value) => {
        if (value !== "") years.add(value);
      });

      const entries = [...years]
        .sort((a, b) => a - b)
        .map((year) => ({ value: year, label: String(year) }));

      this.fillSelect(this.inputs.yearFrom, entries, this.state.yearFrom);
      this.fillSelect(this.inputs.yearTo, entries, this.state.yearTo);
    }

    renderKm() {
      const entries = KM_OPTIONS.map((option) => ({
        option,
        count: this.items.filter((item) => this.match(item, "km") && matchesKm(item, option.key))
          .length,
      }))
        // The mileage scale is fixed: every step stays listed, even when it has no vehicles.
        .map(({ option, count }) => ({ value: option.key, label: `${option.label} (${count})` }));

      this.fillSelect(this.selects.km, entries, this.state.km);
    }

    renderRangeButtons() {
      const config = {
        year: { field: "y", format: (value) => String(value) },
        price: { field: "c", format: formatPrice },
      };

      Object.entries(config).forEach(([name, { field, format }]) => {
        const range = this.ranges[name];
        const from = this.state[`${name}From`];
        const to = this.state[`${name}To`];

        let text = range.placeholder;
        if (from !== "" && to !== "") {
          text = `${format(from)} – ${format(to)}`;
        } else if (from !== "") {
          text = `od ${format(from)}`;
        } else if (to !== "") {
          text = `do ${format(to)}`;
        }
        range.value.textContent = text;
        range.field.classList.toggle("is-active", from !== "" || to !== "");

        const values = this.items
          .filter((item) => item[field] > 0 && this.match(item, name))
          .map((item) => item[field]);
        range.hint.textContent = values.length
          ? `Dostępne: ${format(Math.min(...values))} – ${format(Math.max(...values))}`
          : "";
      });
    }

    renderDmc() {
      const counts = new Map();
      this.items.forEach((item) => {
        if (item.d > 0 && this.match(item, "dmc")) {
          const bucket = DMC_BUCKETS.find((entry) => item.d >= entry.min && item.d <= entry.max);
          if (bucket) {
            counts.set(bucket.key, (counts.get(bucket.key) || 0) + 1);
          }
        }
      });

      const entries = DMC_BUCKETS.filter(
        (bucket) => counts.has(bucket.key) || bucket.key === this.state.dmc,
      ).map((bucket) => ({
        value: bucket.key,
        label: `${bucket.label} (${counts.get(bucket.key) || 0})`,
      }));

      this.fillSelect(this.selects.dmc, entries, this.state.dmc);
    }

    isFiltered() {
      return STATE_KEYS.some((key) => key !== "cat" && this.state[key] !== "");
    }

    disconnectedCallback() {
      this.fab?.remove();
    }

    headerOffset() {
      const header = document.querySelector("sticky-header") || document.querySelector("#header");
      return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    }

    scrollToFilters() {
      const top =
        this.panelEl.getBoundingClientRect().top + window.scrollY - this.headerOffset() - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    }

    updateFab() {
      if (!this.fab) {
        return;
      }

      let visible;
      if (this.isCollection) {
        // Collection page: show once the toolbar's "Filtry" button has scrolled out of
        // view, while the product list is still on screen and the drawer is closed.
        const anchor = this.filterButton?.getBoundingClientRect();
        const list = (
          document.querySelector(".section-main-collection-product-grid") || this
        ).getBoundingClientRect();
        visible =
          Boolean(anchor) &&
          !this.classList.contains("is-loading") &&
          !this.classList.contains("is-open") &&
          anchor.bottom < this.headerOffset() + 8 &&
          list.bottom > window.innerHeight * 0.35;
      } else {
        const panel = this.panelEl.getBoundingClientRect();
        const section = this.getBoundingClientRect();
        visible =
          !this.classList.contains("is-loading") &&
          panel.bottom < this.headerOffset() + 8 &&
          section.bottom > window.innerHeight * 0.35;
      }

      this.fab.classList.toggle("is-visible", visible);
      this.fab.tabIndex = visible ? 0 : -1;
      this.fab.setAttribute("aria-hidden", visible ? "false" : "true");
    }

    activeFilterCount() {
      const s = this.state;
      let count = ["marka", "model", "body", "dmc", "km", "sub"].filter((key) => s[key] !== "").length;
      if (s.yearFrom !== "" || s.yearTo !== "") count++;
      if (s.priceFrom !== "" || s.priceTo !== "") count++;
      return count;
    }

    updateFabCount() {
      if (!this.fabCount) {
        return;
      }

      const count = this.activeFilterCount();
      this.fabCount.textContent = count;
      this.fabCount.hidden = count === 0;
    }

    renderResults(reset) {
      if (reset) {
        this.shown = this.perPage;
        this.matched = this.items.filter((item) => this.match(item));
      }

      const total = this.matched.length;
      const visible = this.matched.slice(0, this.shown);

      this.countEl.innerHTML = total
        ? `<span class="vf-count-label">Znaleziono</span><span class="vf-count-value"><strong>${total}</strong> ${pluralOffers(total)}</span>`
        : `<span class="vf-count-label">Znaleziono</span><span class="vf-count-value">Brak ofert</span>`;
      this.resetButton.disabled = !this.isFiltered();
      this.showAllButton.disabled = total === 0;
      const showLabel = this.isCollection ? "Pokaż wyniki" : "Zobacz wszystkie";
      this.showAllButton.querySelector("span").textContent = total
        ? `${showLabel} (${total})`
        : showLabel;

      if (this.isCollection) {
        const filtered = this.isFiltered();
        this.classList.toggle("is-filtered", filtered);
        document.documentElement.classList.toggle("vf-collection-filtered", filtered);
        if (this.filterBadge) {
          const active = this.activeFilterCount();
          this.filterBadge.textContent = active;
          this.filterBadge.hidden = active === 0;
        }
      }
      this.emptyEl.hidden = total > 0;

      this.gridEl.innerHTML = visible.map((item) => this.cardHtml(item)).join("");

      const remaining = total - visible.length;
      this.moreWrap.hidden = remaining <= 0;
      if (remaining > 0) {
        this.moreButton.textContent = `Pokaż więcej (${remaining})`;
      }

      this.updateFabCount();
      this.updateFab();
    }

    cardHtml(item) {
      const mode = this.dataset.ratioMode;
      let ratio = 1;
      if (mode === "portrait") ratio = 0.8;
      else if (mode === "landscape") ratio = 1.77;
      else if (mode === "adapt") ratio = item.r || 1;

      const widths = [300, 420, 600];
      const image = item.i
        ? `<div class="aspect-ratio" style="--ratio-percent: ${(100 / ratio).toFixed(4)}%;">
            <img
              class="card-media-image"
              src="${escapeHtml(item.i)}"
              srcset="${widths.map((w) => `${escapeHtml(item.i.replace("width=600", `width=${w}`))} ${w}w`).join(", ")}"
              sizes="(min-width: 1200px) 320px, (min-width: 750px) 30vw, 90vw"
              alt="${escapeHtml(item.t)}"
              loading="lazy"
            >
          </div>`
        : "";

      const chips = [];
      if (item.y) chips.push(`<li>${ICONS.year}<span>${item.y}</span></li>`);
      if (item.k) chips.push(`<li>${ICONS.km}<span>${groupDigits(item.k, " ")} kms</span></li>`);
      if (item.d) chips.push(`<li>${ICONS.dmc}<span>${groupDigits(item.d, " ")}</span></li>`);

      const taxSuffix = this.dataset.taxSuffix
        ? ` <span class="sup">${escapeHtml(this.dataset.taxSuffix)}</span>`
        : "";
      const brutto = item.cb
        ? `<div class="price-brutto-line">
            <span class="price-brutto-amount">${escapeHtml(item.cb)}</span>
            <span class="price-brutto-suffix">${escapeHtml(this.dataset.bruttoSuffix || "")}</span>
          </div>`
        : "";

      const cropClass = this.dataset.crop === "true" ? "" : " card-media-contain";

      return `
        <div class="grid-item">
          <div class="card card-product card-product-no-rating ${escapeHtml(this.dataset.cardClass || "")}">
            <figure class="card-media${cropClass}">
              <a href="${escapeHtml(item.u)}" class="js-product-link">${image}</a>
            </figure>
            <div class="card-info-wrap">
              <div class="card-info">
                <h3 class="card-heading typography-${escapeHtml(this.dataset.titleFont || "")}">
                  <a class="js-product-link" href="${escapeHtml(item.u)}" title="${escapeHtml(item.t)}">${escapeHtml(item.t)}</a>
                </h3>
                ${chips.length ? `<div class="card-info-product-meta"><ul>${chips.join("")}</ul></div>` : ""}
              </div>
              <div class="card-footer">
                <div class="price">
                  <div class="price-container">
                    <div class="price-regular">
                      <span class="visually-hidden">Cena regularna</span>
                      <span class="price-item price-item-regular">${escapeHtml(item.cn)}${taxSuffix}</span>
                      ${brutto}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>`;
    }
  }

  customElements.define("vehicle-filter", VehicleFilter);
}
